<template>
	<div class="conmtont">
		<div class="flex radiu-20 bg-white padding-sm">
			<img class="cover margin-right-sm" :src="imgs" >
			<div class="de-cont flex-direction flex justify-between flex-sub">
				<p class="titlw text-32 text-left">{{title}}</p>
				<div class="flex justify-between align-center">
					<div v-if="price != 0" class="text-price text-24 text-bold text-prices text-left margin-top-sm">{{price}}</div>
					<div v-if="price == 0" class="text-24 text-bold text-prices text-left margin-top-sm">免费</div>
				</div>
			</div>
		</div>
		<div class="bg-white dvly padding-lr margin-top padding-top radiu">
			<div class="text-left">支付方式</div>
			<div class="">
				<div class="flex align-center justify-between height126 solid-bottom pointer padding-tb" @click="paytype = 0">
					<div class="flex align-center">
						<img class="block-40 margin-right-sm" src="https://wz89.lzym.top/web/static/home/wechatpay.png" >
						<div>微信支付</div>
					</div>
					<img class="block-30 margin-right-sm" :src="paytype == 0?chek:nochek" >
				</div>
				<div class="flex align-center justify-between height126 solid-bottom pointer padding-tb" v-if="integral != 0" @click="paytype = 1">
					<div class="flex align-center">
						<img class="block-40 margin-right-sm" src="https://wz89.lzym.top/web/static/home/ingrapay.png" >
						<div>积分抵扣</div>
					</div>
					<div class="flex align-center">
						<div class="margin-right-xs">可抵扣积分 <span class="text-theme">{{integral}}</span></div>
						<img class="block-30 margin-right-sm" :src="paytype == 1?chek:nochek" >
					</div>
				</div>
			</div>
		</div>
		
		<div class="padding text-666 fu-fs26">将购买的商品为虚拟课程服务，付款不支持退订、转让、退换请斟酌确认， 购买后可在「个人中心-已购课程」随时观看</div>
		<div class="flex align-center justify-between bg-white padding-sm">
			<div class="flex flex-direction">
				<div class="flex align-center">
					<div class="text-999 fu-fs26 margin-right-sm">应付金额</div>
					<div class="text-price text-prices fu-fs42">{{totalPrice}}</div>
				</div>
				<div class="text-999 fu-fs26" v-if="paytype == 1">当前积分已抵扣 ￥{{integral}}</div>
			</div>
			<div @click="buy" class="pointer text-white text-center call-btn flex align-center bg-theme justify-center">立即支付</div>
		</div>
		
		<!-- 添加章节 -->
		<!-- <Chapter v-if="isadd" @closelogin="closelogin"></Chapter> -->
		<el-dialog width="400px" title="微信支付" @close="closeCode" :visible.sync="show" append-to-body>
		  <div class="paycode text-center">
		    <img :src="qrcode" style="width: 300px;height: 300px;" alt="扫码支付">
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";// 引入qrcode
	import Bus from '@/store/eventBus.js'
	import Chapter from '@/components/my/curriculum/chapter.vue'; //添加章节
	export default {
		components: {
			Chapter
		},
		data() {
			return {
				title:'',
				price:0,
				imgs:'',
				paytype:0,
				chek:require('@/assets/img/chek.png'),
				nochek:require('@/assets/img/nochek.png'),
				integral:0,
				integral_price:0,
				show: false,
				qrcode: '',
				time:null
			}
		},
		created() {
			this.id = this.$route.query.id
			this.getdetail()
		},
		computed: {
			// 选择的商品总价
			totalPrice() {
				let price;
				if (this.paytype == 0) {
					price = this.price
				} else {
					price = this.integral_price
				}
				console.log(price);
				return price;
			},
		},
		methods: {
			/**
			 * 获取详情
			 * */
			getdetail(){
				this.ajax('get', '/api/order/orderInfo', {
					id:this.id,
				}, res => {
					if(res.status == 200){
						
						this.title = res.data.title
						this.price = res.data.price
						this.integral_price = res.data.integral_price
						this.integral = res.data.integral
						this.imgs = res.data.images
						console.log(this.integral);
					}
				})
			},
			//TODO    需要申请v3支付  
			buy(){
				let that = this
				that.ajax('post', '/api/pc/order/save', {
					course_id: that.id,
					integral: that.paytype == 0 ? 0 : that.integral,
					price: that.totalPrice
				}, res => {
					if(res.status == 200){
						if(that.totalPrice == 0){
							that.$message.success('下单成功')
							setTimeout(()=>{
								that.$router.back()
							},300)
						}else{
							that.qrcode = res.data.data
							that.show = true
							// 每秒轮询一次
							clearInterval(this.time);
							let orderid = res.data.order_info.id
							that.time = setInterval(() => {
								that.orderQuery(orderid);
							}, 1000);
						}
					}
				})
			},
			orderQuery(orderid){
				let that = this
				this.ajax('get', '/api/user/getOrderInfo',{
					id:orderid,
				}, res => {
					console.log(res);
					if(res.status == 200){
						if(res.data.status == 1){
							clearInterval(that.time);
							that.$message.success('下单成功')
							setTimeout(()=>{
								that.$router.back()
							},300)
						}
					}else{
						this.$message(res.msg);
					}
				})
			},
			closeCode(){
				clearInterval(that.time);
			}
		}
	}
</script>

<style scoped lang="less">
	.detail{
		width: 782px;
	}
	.cover{
		width: 128px;
		height: 163px;
	}
	.block-40{
		width:40px;
		height: 40px;
	}
	.block-30{
		width: 30px;
		height: 30px;
	}
	.call-btn {
		width: 200px;
		height: 60px;
		line-height: 60px;
		box-shadow: 0px 5px 29px 2px rgba(11, 131, 124, 0.3000);
		border-radius: 40px;
	}
</style>


// WEBPACK FOOTER //
// src/view/buy/buy.vue